{
  "UnifiedNavigation": "Naviguez dans Experience Cloud",
  "adobeExperienceCloudNoOrgsSelect": "Sélectionner le compte d’une autre organisation",
  "help": "Aide",
  "ok": "OK",
  "profile": "Profil",
  "searchButton": "Rechercher",
  "sidenavMenuCloseTooltip": "Fermer le menu",
  "sidenavMenuLockTooltip": "Cliquer pour verrouiller le menu",
  "solutionSwitcher": "Passer à une autre solution",
  "themeCoachMark": "Thème Clair",
  "themeCoachMarkMessage": "L’en-tête Experience Cloud prend désormais en charge les thèmes Clair et Sombre. Cliquez sur votre avatar pour activer votre thème préféré.",
  "toggleSideNav": "Activer/désactiver le menu de navigation latéral"
}
